import { render, staticRenderFns } from "./KioskOrderOverview.vue?vue&type=template&id=50de34c5&scoped=true&"
import script from "./KioskOrderOverview.vue?vue&type=script&lang=js&"
export * from "./KioskOrderOverview.vue?vue&type=script&lang=js&"
import style0 from "./KioskOrderOverview.vue?vue&type=style&index=0&id=50de34c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de34c5",
  null
  
)

export default component.exports